import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
            <div className="pq-section pq-style-1 text-center">
              <span className="pq-section-sub-title">FAQs</span>
              <h2 className="pq-section-title">Frequently Asked Question</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What is CSF Rhinorrhoea?", answer: "CSF Rhinorrhoea is a condition where cerebrospinal fluid leaks from the nose due to a defect in the skull base. It can happen after an injury, surgery, or increased pressure in the brain." },
                  { question: "What are the common symptoms of a CSF leak?", answer: "The main symptom is a clear, watery discharge from the nose, especially when bending forward. Patients may also experience headaches, a salty taste in the throat, or repeated infections like meningitis." },
                  { question: "How is CSF Rhinorrhoea diagnosed?", answer: "Diagnosis involves nasal endoscopy, CT or MRI scans, and specialized tests to confirm that the fluid is CSF. These help locate the exact site of the leak for proper treatment planning." },
                  {question: "What is the treatment for CSF Rhinorrhoea?", answer: "Most patients require endoscopic repair surgery, which is a minimally invasive procedure done through the nose. It seals the leak safely and effectively, with minimal recovery time."},
                  {question: "Is CSF Rhinorrhoea surgery safe and effective?", answer: "Yes. Endoscopic CSF leak repair is considered highly safe and has a very high success rate when performed by an experienced ENT and skull-base surgeon. Early treatment prevents serious infections."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
